"use client";

import Script from "next/script";
import { usePathname } from "next/navigation";
import { useCallback, useEffect, useRef, useState } from "react";

const Z2V_CLIENT_SRC = "https://t.z2v.org/client/track.js";

export const Z2VAnalytics = (): React.ReactElement => {
  const pathname = usePathname();
  const initialized = useRef(false);
  const [ready, setReady] = useState(false);

  const initialize = useCallback((): void => {
    if (initialized.current || !window.Z2VTrack) {
      return;
    }

    window.Z2VTrack.init({
      pageView: false,
    });
    initialized.current = true;
    setReady(true);
  }, []);

  useEffect(() => {
    if (!ready) {
      return;
    }

    void window.Z2VTrack?.track("page_view").catch(() => undefined);
  }, [pathname, ready]);

  return (
    <Script
      src={Z2V_CLIENT_SRC}
      strategy="afterInteractive"
      onReady={initialize}
    />
  );
};
